import React from "react";
import './MemberDirectory.scss'
import MemberDirectoryList from "../../../features/membership/MemberDirectoryList";

const MemberDirectory = () => {
    return (<MemberDirectoryList />);
};

export default MemberDirectory;
